'use strict';

jQuery.fn.boundingRect = function () {
    const left = [];
    const right = [];
    const top = [];
    const bottom = [];

    for (let i = 0, l = this.length; i < l; i++) {
        if (this[i].nodeType === Element.ELEMENT_NODE) {
            const box = this[i].getBoundingClientRect();
            left.push(box.left);
            right.push(box.right);
            top.push(box.top);
            bottom.push(box.bottom);
        }
    }
    const rect = {
        top: Math.min(...top),
        left: Math.min(...left),
        right: Math.max(...right),
        bottom: Math.max(...bottom),
    };
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    return rect;
};
